const veeCustomMessages = {
  en: {
    custom: {
      confirmPassword: {
         required: "Password confirmation is required.",
         confirmed: (confirmPassword, params) => `Password confirmation must match the given password`,
      },
    },
  },
};

export default veeCustomMessages;
